module.exports = __webpack_public_path__ + "img/logo.61d667d7.png";